import { createSlice } from "@reduxjs/toolkit";

export const WorkerDetailSlice = createSlice({
  name: "Worker-detail",
  initialState: {
    workerDetail: null,
  },
  reducers: {
    setWorkerDetail: (state, action) => {
      state.workerDetail = action.payload;
    },
  },
});

export const { setWorkerDetail } = WorkerDetailSlice.actions;

export default WorkerDetailSlice.reducer;
